import moment from 'moment';
import dot from 'dot-object';
import i18next from 'i18next';
import { Popover } from 'antd';
import styled from 'styled-components';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { snakeCaseToTitleCase } from '../../../../../helpers/StringHelper';
import { Link } from 'react-router-dom';
import { isProxy } from 'datastake-daf/src/helpers/Token';
import { openDSWindow } from '../../../../../helpers/Window';
import { useApp, useModule } from '../../../../../helpers/user';

export const Style = styled.div`
  .timeline {
    display: flex;
    justify-content: space-between;
    align-items: space-between;
    height: 300px;

    .weekDay {
      width: 16px;
      text-align: center;
      height: 300px;
      font-size: 10px;
      .dayCol {
        height: 100%;
        width: 100%;
        margin-bottom: 8px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .event {
          width: 100%;
          background: red;
          height: 35px;
          border-radius: 2px;
          z-index: 1;
          margin-top: 2px;
          cursor: pointer;
          opacity: 0.8;
          transition: opacity 0.3s ease-in-out;
          &:hover{
            opacity: 1;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
          }
        }
        &::after {
          content: '';
          position: absolute;
          width: 1px;
          height: 100%;
          background: #F2F2F2;
          top: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
  }
`;

const EventsTooltip = styled.div`
  width: 200px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  h1 {
    font-size: 17px;
    font-weight: 700;
    color: #001529;
    margin-bottom: 0px;
  }

  h4 {
    font-weight: 500;
    font-size: 13px;
    color: var(--color-primary-70);
    margin-bottom: 0px;
  }

  .desc {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  p {
    font-weight: 300;
    font-size: 13px;
    color: #001529;
    margin-bottom: 0px;
    line-height: 13px;
    
    &.reported-by {
      font-weight: 500;
    }
  }

  .severity {
    display: flex;

    h3 {
      font-size: 15px;
      font-weight: 500;
      margin-left: 4px;
      margin-bottom: 0px;
    }
  }

  .cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .ant-tag {
    margin-right: 0px;
    width: fit-content;

  }
`;

const MeasuresTooltip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .header {
    h1 {
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 4px;
      color: #001529;
    }

    h2 {
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 4px;
      color: var(--color-primary-70);
    }

    p {
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 4px;
      color: #001529;

      &.date {
        font-weight: 300;
        margin-bottom: 0px;
      }
    }
  }

  .action {
    margin-bottom: 0px;
    font-weight: 500;
    color: #001529;
    font-size: 13px;
  }
`;

const measureLabels = {
  proposed: 'Proposed Measure',
  inProgress: 'In-progress Measure',
  completed: 'Completed Measure',
}

export const getColors = (type = 'INCIDENTS') => {
  switch (type) {
    case 'INCIDENTS':
      return {
        major: '#FF4D4F',
        moderate: '#FA8C16',
        minor: '#FADB14',
        riskMitigationMeasures: '#52C41A',
      };
    case 'Measures':
      return {
        proposed: '#C2B3D8',
        inProgress: '#597EF7',
        completed: '#52C41A',
      };
    default:
      return {};

  }
}

export const TooltipEvent = ({ tooltipExtra, ev, isSingleSource, dateKey, colors, mode = 'app', mod = 'pme' }) => (
  <EventsTooltip>
    <h1>{ev.datastakeId}</h1>
    <div className="desc">
      <h4>{ev.title}</h4>
      {(ev.reportedBy && !isSingleSource) && (
        <p className="reported-by">
          {i18next.t('Reported by')}: {ev.reportedBy}
        </p>
      )}
      <p>
        {i18next.t('Recorded on')}:
        {' '}
        {moment(ev[dateKey]).format('DD MMMM YYYY')}
      </p>
    </div>
    {ev.incidentSeverity && (
      <div className="severity">
        <div className="cont">
          <svg width="13" height="13" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 4L6 7.4641L2 7.4641L-1.74846e-07 4L2 0.535898L6 0.535898L8 4Z" fill={colors[ev.incidentSeverity]} />
          </svg>
        </div>
        <h3>
          {ev.category ? (
            i18next.t(`${(ev.category || {}).label} ${(ev.category || {}).value === 'corrective' ? 'Action' : 'Incident'}`)
          ) : i18next.t(`${snakeCaseToTitleCase(ev.incidentSeverity)} Incident`)}
        </h3>
      </div>
    )}
    <div className="">
      {mode !== 'proxy' ? (
        <div className="w-100 text-center">
          <Link target="_blank" to={`/app/${mod}/view/event/${ev.datastakeId}`}>{i18next.t('View More')}</Link>
        </div>
      ) : (
        <div className="w-100 text-center">
          <span
            style={{ color: 'var(--mmt-primary-70)', cursor: 'pointer' }}
            onClick={() => {
              openDSWindow({
                url: `/proxy/${mod}/view/event/${ev.datastakeId}`,
                name: `Datastake Event Proxy ${ev.title}`,
              });
            }}>
            {i18next.t('View More')}
          </span>
        </div>
      )}
      {typeof tooltipExtra === 'function' ? tooltipExtra(ev) : null}
    </div>
  </EventsTooltip>
)

const mode = isProxy() ? 'proxy' : 'app';

export default function StackChart({
  data = [],
  period = 'monthly',
  type = 'INCIDENTS',
  isSingleSource = false,
  className,
  noProvider = false,
  tooltipExtra,
  renderTooltip,
  yOffset = 130,
  xOffset = 230,
  mouseXOffset = 30,
  mouseYOffset = 50,
  doConstraints = true,
  pastWeeks = 6,
  defaultDateKey,
}) {
  const app = useApp();
  const ref = useRef();
  const colors = getColors(type, app);
  const { mod } = useModule();
  const isEmpty = !data.length;
  const [mouseY, setMouseY] = useState(0);
  const [mouseX, setMouseX] = useState(0);
  const [hoveredGroup, setHoveredGroup] = useState(null);

  const getPastMonths = () => {
    const lang = moment.locale();
    const fromDate = moment().subtract(11, 'months').startOf('month').add(lang === 'en' ? 1 : 0, 'day')
    const toDate = moment().endOf('months').add(lang === 'en' ? 1 : 0, 'day');
    const diff = toDate.diff(fromDate, 'months');
    const range = [];
    for (let i = 0; i <= diff; i++) {
      range.push(moment(fromDate).add(i, 'months'));
    }
    return range;
  }

  const getPastWeeks = () => {
    const lang = moment.locale();
    const fromDate = moment().subtract(pastWeeks, 'weeks').startOf('week').add(lang === 'en' ? 1 : 0, 'day')
    if (groupedData) {
      const keys = Object.keys(groupedData).map((s) => parseInt(s.split('W')[1]));
      const min = Math.min(...keys);
      if (min < parseInt(fromDate.format('W'))) {
      }
    }
    const toDate = moment().endOf('week').add(lang === 'en' ? 1 : 0, 'day');
    const diff = toDate.diff(fromDate, 'weeks');
    const range = [];
    for (let i = 0; i <= diff; i++) {
      range.push(moment(fromDate).add(i, 'weeks'));
    }
    return range;
  }

  const dateKey = useMemo(() => {
    switch (type) {
      case 'Measures':
        return defaultDateKey || 'createdAt';
      default:
        return defaultDateKey || 'dateOfEvent';
    }
  }, [type]);

  const groupByMonth = (all = []) => {
    const arr = all;
    return arr.reduce((r, a) => {
      const objKey = moment(dot.pick(dateKey, a)).format('MMM-YYYY');
      if (!r[objKey]) {
        r[objKey] = [a];
      } else if (Array.isArray(r[objKey])) {
        if (r[objKey].length < 100) {
          r[objKey].push(a);
        }
      }
      return r;
    }, {});
  }

  const groupByWeek = (all = []) => {
    const arr = all;
    return arr.reduce((r, a) => {
      const objKey = moment(dot.pick(dateKey, a)).format('[W]WW-YYYY');

      if (!r[objKey]) {
        r[objKey] = [a];
      } else if (Array.isArray(r[objKey])) {
        if (r[objKey].length < 100) {
          r[objKey].push(a);
        }
      }
      return r;
    }, {});
  }

  const groupedData = period === 'monthly' ? groupByMonth(data) : groupByWeek(data);
  let max = 0;

  Object.keys(groupedData).forEach(g => {
    if (max < groupedData[g].length) {
      max = groupedData[g].length;
    }
  });

  const getEventHeight = () => {
    const MARGIN = 2;
    const height = Math.abs(parseFloat(((300 - max * MARGIN) / max).toFixed(2)));
    return height > 35 ? 35 : height;
  }

  const height = getEventHeight();

  const getEventContent = (ev) => {
    if (typeof renderTooltip === 'function') {
      return renderTooltip(ev);
    }

    if (type === 'INCIDENTS') {
      return (
        <TooltipEvent
          mode={mode}
          mod={mod}
          ev={ev}
          isSingleSource={isSingleSource}
          dateKey={dateKey}
          colors={colors}
          tooltipExtra={tooltipExtra}
        />
      );
    }

    if (type === 'Measures') {
      return (
        <MeasuresTooltip>
          <div className="header">
            <h1>{measureLabels[ev.type]}</h1>
            <h2>{ev.measure}</h2>
            <p>{ev.riskSubcategory}</p>
            {(!isSingleSource && ev.reportedBy) ? (
              <p className="reported-by">
                {i18next.t('By')}: {ev.reportedBy}
              </p>
            ) : null}
            <p className="date">
              {i18next.t('Created on')}:
              {' '}
              {moment(ev.createdAt).format('DD MMMM YYYY')}
            </p>
          </div>
          {(ev.events || []).length ? (
            <p className="action">
              {ev.events.length}
              {' '}
              {i18next.t('actions associated')}
            </p>
          ) : (
            <p className="action">
              {i18next.t('No action associated')}
            </p>
          )}
        </MeasuresTooltip>
      );
    }

    return null;
  };

  const getColor = (item) => {
    switch (type) {
      case 'INCIDENTS':
        if (item.typeOfEvent === 'riskMitigationMeasures') {
          return colors.riskMitigationMeasures;
        }
        return colors[item.incidentSeverity];
      case 'Measures':
        return colors[item.type];
      default:
        return '';
    }
  }

  const content = () => {
    if (period === 'monthly') {
      return getPastMonths().map(day => (
        <div className="weekDay" key={day.format('MMM')}>
          <div className="dayCol">
            {groupedData[day.format('MMM-YYYY')] ? groupedData[day.format('MMM-YYYY')].map((ev, ind) => (
              <Popover
                overlayClassName="event-popover"
                placement="left"
                key={ind}
                title={null}
                content={getEventContent(ev)}
              >
                <div
                  className="event"
                  style={{
                    background: getColor(ev),
                    height: `${height < 1 ? 1 : height}px`,
                  }}
                />
              </Popover>
            )) : null}
          </div>
          {day.format(`MMM`)}
        </div>
      ));
    } else {
      return getPastWeeks().map(day => (
        <div className="weekDay" key={day.format('[W]WW')}>
          <div className="dayCol">
            {groupedData[day.format('[W]WW-YYYY')] ? groupedData[day.format('[W]WW-YYYY')].map((ev, ind) => (
              <Popover
                overlayClassName="event-popover"
                placement="left"
                key={ind}
                content={getEventContent(ev)}
              >
                <div className="event" style={{
                  background: getColor(ev),
                  height: `${height < 1 ? 1 : height}px`,
                }}></div>
              </Popover>
            )) : null}
          </div>
          {day.format(`[${i18next.t('weekSymbbol')}]WW`)}
        </div>
      ));
    }
  };

  const onMouseLeaveHandler = useCallback((e, hG, id) => {
    let x = e.clientX - ref.current.getBoundingClientRect().left + mouseXOffset;
    let y = e.clientY - ref.current.getBoundingClientRect().top + mouseYOffset;

    if (doConstraints && ref.current.clientWidth - x < xOffset) {
      x = ref.current.clientWidth - xOffset;
    }

    if (doConstraints && ref.current.clientHeight - y < yOffset) {
      y = 0;
      x = ref.current.clientWidth / 2 - 100;
    }

    setMouseY(y);
    setMouseX(x);

    if (hoveredGroup === null) {
      setHoveredGroup({ ...hG, id });
    }
  }, [hoveredGroup]);

  if (noProvider) {
    return (
      <Style className={formatClassname(['timeline', className])} ref={ref}>
        {content()}
      </Style>
    );
  }

  return (
    <Style
      {...(isEmpty ? {
        onMouseEnter: () => {
          setHoveredGroup({ id: 0 })
        },
        onMouseLeave: () => {
          setHoveredGroup(null)
        },
        onMouseMove: (e) => onMouseLeaveHandler(e, {}, 0),
      } : {})}
      className={formatClassname(['riskProfile', className])} ref={ref}>
      {
        typeof renderTooltip === 'function' ?
          hoveredGroup !== null ?
            renderTooltip({ mouseX, mouseY, item: hoveredGroup })
            : null
          : null
      }
      <div className="timeline">
        {content()}
      </div>
    </Style>
  );
}
